import React, { useState } from 'react';
import axios from 'axios';
import Layout from '../Components/Layout'
import Swal from 'sweetalert2'
import config from '../config';
import { useLanguage } from '../context/LanguageContext';

export default function Contact() {
    const { translations } = useLanguage();
    const t = translations.contact || {};
    const [loading, setLoading] = useState(false);
    const userData = JSON.parse(localStorage.getItem('user_data'));
    const [formData, setFormData] = useState({
        name:'',
        surname:'',
        phone:'',
        email:'',
        message:'',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);
        try {
            const response = await axios.post(`${config.API_BASE_URL_V1}subscribe/create`, formData, {
                headers: {
                    Authorization: `Bearer ${userData.token}`,
                },
            });
    
            if (response.status !== 201) {
                Swal.fire({
                    position: "center",
                    icon: "error",
                    title: t.alerts.error,
                    showConfirmButton: false,
                    timer: 1500,
                });
            } else {
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: t.alerts.success,
                    showConfirmButton: false,
                    timer: 1500,
                });
    
                setFormData({}); 
    
                e.target.reset(); 
            }
        } catch (error) {
            Swal.fire({
                position: "center",
                icon: "error",
                title: t.alerts.unexpectedError,
                showConfirmButton: false,
                timer: 1500,
            });
        }
        finally
        {
            setLoading(false);
        }
    };
    
  return (
    <Layout>
        <div className="breadcrumb-bar breadcrumb-bg-02 text-center">
            <div className="container">
                <div className="row">
                    <div className="col-md-12 col-12">
                        <h2 className="breadcrumb-title mb-2">{t.breadcrumb.title}</h2>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb justify-content-center mb-0">
                                <li className="breadcrumb-item"><a href="/"><i className="isax isax-home5"></i> {t.breadcrumb.home}</a></li>
                                <li className="breadcrumb-item">{t.breadcrumb.pages}</li>
                                <li className="breadcrumb-item active" aria-current="page">{t.breadcrumb.title}</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>

        <div className="content">
            <div className="container">
                <div className="row align-items-center row-gap-4">
                    <div className="col-xl-7 col-lg-7">
                        <div className="mb-4 mb-lg-0">
                            <div className="row">
                                <div className="col-md-8">
                                    <h2 className="mb-3">{t.mainContent.title}</h2>
                                </div>
                            </div>
                            <div className="mb-4">
                                <h6 className="mb-2">{t.mainContent.subtitle}</h6>
                                <p>{t.mainContent.description}</p>
                            </div>
                            <div className="border-bottom mb-4">
                                <div className="d-flex align-items-center mb-4">
                                    <span className="avatar avatar-lg rounded-circle bg-light  text-gray-6 me-2"><i className="isax isax-sms5 fs-24"></i></span>
                                    <div>
                                        <p className="fs-14 mb-0">{t.contactInfo.email.label}</p>
                                        <h6 className="text-gray-6">{t.contactInfo.email.value}</h6>
                                    </div>
                                </div>
                            </div>
                            <div className="border-bottom mb-4">
                                <div className="d-flex align-items-center mb-4">
                                    <span className="avatar avatar-lg rounded-circle bg-light  text-gray-6 me-2"><i className="isax isax-call-calling5 fs-24"></i></span>
                                    <div>
                                        <p className="fs-14 mb-0">{t.contactInfo.phone.label}</p>
                                        <h6 className="text-gray-6">{t.contactInfo.phone.value}</h6>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="d-flex align-items-center">
                                    <span className="avatar avatar-lg rounded-circle bg-light  text-gray-6 me-2"><i className="isax isax-map-15 fs-24"></i></span>
                                    <div>
                                        <p className="fs-14 mb-0">{t.contactInfo.address.label}</p>
                                        <h6 className="text-gray-6">{t.contactInfo.address.value}</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-5 col-lg-5">
                        <div className="card bg-light-200 shadow-none mb-0">
                            <div className="card-body">
                                <div className="mb-3">
                                    <h2 className="mb-1">{t.form.title}</h2>
                                    <p className="text-gray-6 mb-1">{t.form.subtitle}</p>
                                </div>
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    {t.form.firstName.label} <span className="text-danger">{t.form.firstName.required}</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="name"
                                                    value={formData.firstName}
                                                    onChange={handleChange}
                                                    className="form-control"
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    {t.form.lastName.label} <span className="text-danger">{t.form.lastName.required}</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="surname"
                                                    value={formData.lastName}
                                                    onChange={handleChange}
                                                    className="form-control"
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    {t.form.email.label} <span className="text-danger">{t.form.email.required}</span>
                                                </label>
                                                <input
                                                    type="email"
                                                    name="email"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    className="form-control"
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    {t.form.phone.label} <span className="text-danger">{t.form.phone.required}</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="phone"
                                                    value={formData.phone}
                                                    onChange={handleChange}
                                                    className="form-control"
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="mb-3">
                                                <label className="form-label">
                                                    {t.form.message.label} <span className="text-danger">{t.form.message.required}</span>
                                                </label>
                                                <textarea
                                                    name="message"
                                                    value={formData.message}
                                                    onChange={handleChange}
                                                    className="form-control"
                                                    rows="3"
                                                ></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    {loading ? 
                                        <div className="d-flex align-items-center justify-content-center">
                                            <button type="submit" className="btn btn-primary" disabled>{t.form.button.loading}</button>
                                        </div>
                                        :
                                        <div className="d-flex align-items-center justify-content-center">
                                            <button type="submit" className="btn btn-primary">{t.form.button.submit}</button>
                                        </div>
                                    }
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="map-grid">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6020.906936909632!2d28.944593!3d41.015334!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14caba245233c19d%3A0x48ee9d1b10c9a53c!2sAk%C5%9Femsettin%2C%20%C5%9Eair%20Fuzuli%20Sk.%2C%2034080%20Fatih%2F%C4%B0stanbul!5e0!3m2!1str!2str!4v1734610607940!5m2!1str!2str" width="100%" height="400" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
            </div>
        </div>
    </Layout>
  )
}
